export default __webpack_public_path__ + "static/media/PropertyDev_IMG-Mahligai.35b06ff0.png";